import { ArrowBackIos } from "@mui/icons-material";
import { CircularProgress, Divider } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getAllRecordsByUser } from "../../../../../api/store";
import AppLayout from "../../../../../layout/DashboardLayout";
import { storeSelector } from "../../../../../redux/slices/storeSlice";
import UserDetailsTab from "./UserDetailsTab";

export default function UserDetails() {
  const dispatch = useDispatch();
  const dataFetchedRef = useRef(false);
  const params = useParams();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState("");

  const { allUsers } = useSelector(storeSelector);

  const findUser = allUsers?.users?.find(
    (user) => user._id.toString() === params.id.toString()
  );

  // useEffect(() => {
  //   if (dataFetchedRef.current) return;
  //   dataFetchedRef.current = true;
  //   // dispatch(getAllUsers({ page: 0, size: 20 }));
  //   setIsLoaded(false);
  //   dispatch(getAllRecordsByUser(params.id)).then(({payload}) => {
  //     setIsLoaded(true)
  //   });
  // }, [dispatch, params.id]);

  return (
    <AppLayout background="#f1f1f1">
      <div style={{ display: "flex" }}>
        <div onClick={() => navigate(-1)}>
          <ArrowBackIos
            sx={{
              fontSize: "18px",
              color: "#9d9d9d",
              cursor: "pointer",
              marginTop: "9.2px",
            }}
          />
        </div>
        <div>
          <h4 style={{ margin: 0 }}>
            {findUser?.first_name + " " + findUser?.last_name}
          </h4>
          <h6 style={{ marginTop: 10 }}>{findUser?.email}</h6>
        </div>
        {/* <h6>{findUser?.first_name + " " + findUser?.last_name}</h6> */}
      </div>
      <Divider />
        <UserDetailsTab findUser={findUser} />
    
    </AppLayout>
  );
}
